import { WebClientStore } from "web-client-store";
import jwt, {JwtPayload } from "jsonwebtoken";
import SessionStorage from "web-client-store/SessionStorage";
import LocalStorage from "web-client-store/LocalStorage";
import CookieStorage from "web-client-store/CookieStorage";
import IndexedStorage from "web-client-store/IndexedStorage";
import Constants from "./constants";

let { Cookie, Session, Local, Indexed } = WebClientStore;
// Infer the types
let _cookie: CookieStorage = Cookie;
let _local: LocalStorage = Local;
let _session: SessionStorage = Session;
let _index: IndexedStorage = Indexed;

let { SESSION_KEYS, COOKIE_KEYS, LOCAL_KEYS, INDEXED_KEYS } = Constants;
let console = { debug: (...params: any[]) => { if (false) global.console.debug(...params) } }
export const getTokenExpiry = () => {
  let time = "expired";
  try {
    const token = getSession();
    console.debug('session tokne found', token);
    const _token: JwtPayload | null = jwt.decode(token, {complete: true, json: true});
    console.debug('token extracted', _token)
    if (_token && _token.payload && _token.payload.exp) {
        let x = _token.payload.exp - new Date().getTime() / 1000;
        time = Constants.secondsToDhmsTime(x);
    }
    console.debug('time', time);
  } catch (error) {
    console.error(error);
  }
  return time;
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const _token: JwtPayload | null = jwt.decode(token, {complete: true, json: true});
    if (_token && _token.payload && _token.payload.exp) {
      const expirationDatetimeInSeconds = _token.payload.exp * 1000;
      return Date.now() >= expirationDatetimeInSeconds;
    }
  } catch {
    //
  }
  return true;
};

export const isAuthenticated = () => !isTokenExpired(getSession());

export const isAuthorizedSiteAdmin = () => {
  let previleges = _session.get(SESSION_KEYS.USER_PREVILEGES);
  if (previleges) {
    let _retrieved = JSON.parse(previleges);
    return _retrieved && _retrieved.isAdmin && _retrieved.isAdmin === true;
  } else return false;
};
export const getSession = () => _cookie.get(COOKIE_KEYS.SESSION);
export const setSession = (token: string) => {
  _cookie.set(COOKIE_KEYS.SESSION, token);
};
export const killSession = async () => {
  _cookie.unset(COOKIE_KEYS.SESSION);
  _local.unset(LOCAL_KEYS.REFRESH_TOKEN);

  _session.clear();

  _index.unsetAsync(INDEXED_KEYS.ACCOUNTS).then(() => {
    _index.unsetAsync(INDEXED_KEYS.SUBSCRIBERS).then(() => {
      _index.unsetAsync(INDEXED_KEYS.ACCT_TYPES).then(() => {
        _index.unsetAsync(INDEXED_KEYS.CURRENCIES).then(() => {
          _local.unset(LOCAL_KEYS.ACTIVE_ACCOUNT_GRID_MODE);
          // console.log("logout successful.");
        });
      });
    });
  });
};
export const setRefreshToken = (refreshToken: string) => {
  _local.set(LOCAL_KEYS.REFRESH_TOKEN, refreshToken);
};
export const getRefreshToken = () => _local.get(LOCAL_KEYS.REFRESH_TOKEN);
